<template>
    <app-layout :racingstars="$page.props.racingstars" :jetstream="$page.props.jetstream" :user="$page.props.user" title="Played">
        <template #header>
            Played
        </template>
        <div v-if="!$page.props.user.active_bet" class="sm:p-6">
            <div class="sm:py-4">
                <div v-if="meeting && meeting.abandoned !== 1">
                    <tw-card maxHeight="runners-card" v-if="$page.props.user.play_tokens" height="dark:bg-gray-700 dark:sm:bg-gray-800 h-auto">
                        <alert class="mb-4" v-if="meeting.finished_at" type="info">
                            <template #title>
                                Today's Meeting Has Now Finished!
                            </template>
                            <template #message>
                                Below are the results of each race. Check back again tomorrow for a new meeting and a new chance to play Racing Stars.
                            </template>
                        </alert>
                        <race-stepper :non-runners="nonRunners" :reserves="reserves" :meeting="meeting" :user="user" />
                    </tw-card>
                    <div v-else>
                        <alert type="info">
                            <template #title>
                                You don't have any stars to play with!
                            </template>
                            <template #message>
                                Purchase a stars package in order to place a bet and play Racing Stars.
                            </template>
                        </alert>
                    </div>
                </div>
                <alert v-else-if="eventTitle" type="info">
                    <template #title>
                        <div class="grid grid-cols-2 gap-2">
                            <div class="flex col-span-1">
                                {{ eventTitle }}
                            </div>
                            <div class="flex col-span-1">
                                <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                            </div>
                        </div>
                    </template>
                    <template #message>
                        {{ eventSubtitle }}
                    </template>
                </alert>
                <alert v-else type="info">
                    <template #title>
                        <div class="grid grid-cols-2 gap-2">
                            <div class="flex col-span-1">
                                Awaiting Daily Meeting Data!
                            </div>
                            <div class="flex col-span-1">
                                <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                                </svg>
                            </div>
                        </div>
                    </template>
                    <template #message>
                        Please wait whilst we fetch the latest meeting data.
                    </template>
                </alert>
            </div>
        </div>
        <div v-else class="py-4 px-6 pb-16">
            <div class="py-4">
                <alert type="info">
                    <template #title>
                        Thanks for Playing Racing Stars!
                    </template>
                    <template #message>
                        As we are responsible gambling advocates, we only allow users to place a single bet per day, spending just 1 token worth £1. This keeps everyone safe, and reduces a user's maximum spend to just £30 in any 30 day period.<br /><br />
                        Check back tomorrow to place another bet.
                    </template>
                </alert>
            </div>
        </div>
    </app-layout>
</template>
<script>
import { ref, onMounted, getCurrentInstance, computed } from 'vue'
import AppLayout from '@/Layouts/Layout.vue'
import TwCard from '@/Global/Elements/TwCard.vue'
import Alert from '@/Global/Alert.vue'
import RaceStepper from './Partials/RaceStepper.vue'
import { useStore } from 'vuex'
import { RefreshIcon } from '@heroicons/vue/outline'
import moment from 'moment'
import { Inertia } from '@inertiajs/inertia'

export default {
    props: {
        user: Object,
        meeting: Object,
        nonRunners: Object,
        reserves: Object,
    },

    components: {
        AppLayout,
        TwCard,
        RaceStepper,
        RefreshIcon,
        Inertia,
    },

    setup(props) {
        const store = useStore()
        const eventTitle = ref()
        const eventSubtitle = ref()

        if (props.user.active_bet) {
            Inertia.get('dashboard')
        }

        onMounted(() => {
            if (props.meeting && !props.meeting.abandoned) {
                store.commit('setGameState', props.meeting.races)
            }

            Echo.channel('results')
                .listen('RaceResultsUpdated', (e) => {
                    if (route().current() === 'play') {
                        Inertia.reload({ only: ['meeting'] })
                    }
                })

            // if (!props.meeting || props.meeting.abandoned) {
            //     Inertia.post('meetings')

            //     Echo.channel('meetings')
            //         .listen('DailyMeetingDataAcquired', (e) => {
            //             eventTitle.value = 'Meeting & Race Data Acquired.'
            //             eventSubtitle.value = 'Please wait whilst we finalise the meeting.'

            //             setTimeout(() => {
            //                 if (route().current() === 'play') {
            //                     Inertia.reload({ only: ['meeting'] })
            //                 }
            //             }, 10000)
            //         });
            // }
        })

        return {
            eventTitle,
            eventSubtitle,
            moment,
        }

    }
}

</script>
